// extracted by mini-css-extract-plugin
export default {"appErrorBoundary":"mfr-__AGDDEx","clearCacheButton":"mfr-Q1XLDZhV"};